import React from 'react';
import { Block, BLOCKS, INLINES, Inline } from '@contentful/rich-text-types';
import { RenderNode } from '@contentful/rich-text-react-renderer';

import { IFullwidthHero20Fields } from '../../../types/contentful';

import Link from 'next/link';
import RichText from '../RichText';
import { EmbeddedInlineEntryNode } from '../RichText/Nodes';

// Removed Emotion-based styles in favor of Tailwind

type DesktopPolicyDisclaimerFields = Pick<
  IFullwidthHero20Fields,
  'desktopImageDisclaimer'
>;

interface DesktopPolicyDisclaimerProps extends DesktopPolicyDisclaimerFields {
  alignContentToLeft?: boolean;
  noMargin?: boolean;
  colorHex?: string;
}

export default function DesktopImageDisclaimer({
  desktopImageDisclaimer,
  noMargin = false
}: DesktopPolicyDisclaimerProps) {
  const RICH_TEXT_OVERRIDE: RenderNode = {
    [BLOCKS.PARAGRAPH]: (_node: Block | Inline, children) => {
      return (
        <p className="max-w-[272px] text-[#757575] tablet:text-center desktop:min-w-0 desktop:max-w-[496px]">
          {children}
        </p>
      );
    },
    [BLOCKS.HEADING_6]: (_node: Block | Inline, children) => (
      <p className="mb-4 font-medium">{children}</p>
    ),
    [INLINES.HYPERLINK]: (node, children) => {
      const href = node.data.uri as string;
      return (
        <Link
          href={href}
          className="hover:text-green-600 underline underline-offset-2"
        >
          {children}
        </Link>
      );
    },
    [INLINES.EMBEDDED_ENTRY]: (node, children) => (
      <EmbeddedInlineEntryNode node={node} colour="defaultText" fontWeight="p">
        {children}
      </EmbeddedInlineEntryNode>
    )
  };

  return (
    <div className="col-span-12 mx-auto tablet:mx-0">
      <div
        className={`flex flex-row items-center justify-between ${
          noMargin ? 'm-0' : 'm-auto tablet:m-0'
        }`}
      >
        <div className="flex flex-col">
          <RichText
            data={desktopImageDisclaimer}
            overrideOptions={RICH_TEXT_OVERRIDE}
          />
        </div>
      </div>
    </div>
  );
}
